var render, staticRenderFns
import script from "./detail_log.vue?vue&type=script&lang=js"
export * from "./detail_log.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd09a094')) {
      api.createRecord('bd09a094', component.options)
    } else {
      api.reload('bd09a094', component.options)
    }
    
  }
}
component.options.__file = "found/views/dms/views/rebate/rebate_policy/form/detail_log.vue"
export default component.exports